var isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i)
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i)
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i)
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i)
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i)
    },
    any: function () {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows())
    }
};

/**
 * @license
 * Lodash (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash include="debounce,throttle"`
 */
;
(function () {
    function t() {}

    function e(t) {
        return null == t ? t === l ? d : y : I && I in Object(t) ? n(t) : r(t)
    }

    function n(t) {
        var e = $.call(t, I),
            n = t[I];
        try {
            t[I] = l;
            var r = true
        } catch (t) {}
        var o = _.call(t);
        return r && (e ? t[I] = n : delete t[I]), o
    }

    function r(t) {
        return _.call(t)
    }

    function o(t, e, n) {
        function r(e) {
            var n = d,
                r = g;
            return d = g = l, x = e, v = t.apply(r, n)
        }

        function o(t) {
            return x = t, O = setTimeout(c, e), T ? r(t) : v
        }

        function i(t) {
            var n = t - h,
                r = t - x,
                o = e - n;
            return w ? k(o, j - r) : o
        }

        function f(t) {
            var n = t - h,
                r = t - x;
            return h === l || n >= e || n < 0 || w && r >= j
        }

        function c() {
            var t = D();
            return f(t) ? p(t) : (O = setTimeout(c, i(t)), l)
        }

        function p(t) {
            return O = l, S && d ? r(t) : (d = g = l, v)
        }

        function s() {
            O !== l && clearTimeout(O), x = 0, d = h = g = O = l
        }

        function y() {
            return O === l ? v : p(D())
        }

        function m() {
            var t = D(),
                n = f(t);
            if (d = arguments, g = this, h = t, n) {
                if (O === l) return o(h);
                if (w) return O = setTimeout(c, e), r(h)
            }
            return O === l && (O = setTimeout(c, e)), v
        }
        var d, g, j, v, O, h, x = 0,
            T = false,
            w = false,
            S = true;
        if (typeof t != "function") throw new TypeError(b);
        return e = a(e) || 0, u(n) && (T = !!n.leading, w = "maxWait" in n, j = w ? M(a(n.maxWait) || 0, e) : j, S = "trailing" in n ? !!n.trailing : S),
            m.cancel = s, m.flush = y, m
    }

    function i(t, e, n) {
        var r = true,
            i = true;
        if (typeof t != "function") throw new TypeError(b);
        return u(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), o(t, e, {
            leading: r,
            maxWait: e,
            trailing: i
        })
    }

    function u(t) {
        var e = typeof t;
        return null != t && ("object" == e || "function" == e)
    }

    function f(t) {
        return null != t && typeof t == "object"
    }

    function c(t) {
        return typeof t == "symbol" || f(t) && e(t) == m
    }

    function a(t) {
        if (typeof t == "number") return t;
        if (c(t)) return s;
        if (u(t)) {
            var e = typeof t.valueOf == "function" ? t.valueOf() : t;
            t = u(e) ? e + "" : e
        }
        if (typeof t != "string") return 0 === t ? t : +t;
        t = t.replace(g, "");
        var n = v.test(t);
        return n || O.test(t) ? h(t.slice(2), n ? 2 : 8) : j.test(t) ? s : +t
    }
    var l, p = "4.17.4",
        b = "Expected a function",
        s = NaN,
        y = "[object Null]",
        m = "[object Symbol]",
        d = "[object Undefined]",
        g = /^\s+|\s+$/g,
        j = /^[-+]0x[0-9a-f]+$/i,
        v = /^0b[01]+$/i,
        O = /^0o[0-7]+$/i,
        h = parseInt,
        x = typeof global == "object" && global && global.Object === Object && global,
        T = typeof self == "object" && self && self.Object === Object && self,
        w = x || T || Function("return this")(),
        S = typeof exports == "object" && exports && !exports.nodeType && exports,
        N = S && typeof module == "object" && module && !module.nodeType && module,
        E = Object.prototype,
        $ = E.hasOwnProperty,
        _ = E.toString,
        W = w.Symbol,
        I = W ? W.toStringTag : l,
        M = Math.max,
        k = Math.min,
        D = function () {
            return w.Date.now()
        };
    t.debounce = o, t.throttle = i, t.isObject = u, t.isObjectLike = f, t.isSymbol = c, t.now = D, t.toNumber = a, t.VERSION = p, typeof define == "function" && typeof define.amd == "object" && define.amd ? (w._ = t, define(function () {
        return t
    })) : N ? ((N.exports = t)._ = t, S._ = t) : w._ = t
}).call(this);


// Confetti - modified from: https://github.com/daniel-lundin/dom-confetti
var defaultColors3 = ["#ffffff", "#ffffff", "#ffffff"];

function createElements(root, elementCount, colors, width, height) {
  return Array.from({
      length: elementCount,
  }).map(function(_, index) {
      var element = document.createElement("div");
      var color = colors[index % colors.length];
      element.style["background-color"] = color; // eslint-disable-line space-infix-ops

      element.style.width = width;
      element.style.height = height;
      element.style.position = "absolute";
      element.style.willChange = "transform, opacity";
      element.style.visibility = "hidden";
      root.appendChild(element);
      return element;
  });
}

function randomPhysics(angle, spread, startVelocity, random) {
  var radAngle = angle * (Math.PI / 180);
  var radSpread = spread * (Math.PI / 180);
  return {
      x: 0,
      y: 0,
      z: 0,
      wobble: random() * 10,
      wobbleSpeed: 0.1 + random() * 0.1,
      velocity: startVelocity * 0.5 + random() * startVelocity,
      angle2D: -radAngle + (0.5 * radSpread - random() * radSpread),
      angle3D: -(Math.PI / 4) + random() * (Math.PI / 2),
      tiltAngle: random() * Math.PI,
      tiltAngleSpeed: 0.1 + random() * 0.3,
  };
}

function updateFetti(fetti, progress, dragFriction, decay) {
  /* eslint-disable no-param-reassign */
  fetti.physics.x += Math.cos(fetti.physics.angle2D) * fetti.physics.velocity;
  fetti.physics.y += Math.sin(fetti.physics.angle2D) * fetti.physics.velocity;
  fetti.physics.z += Math.sin(fetti.physics.angle3D) * fetti.physics.velocity;
  fetti.physics.wobble += fetti.physics.wobbleSpeed; // Backward compatibility

  if (decay) {
      fetti.physics.velocity *= decay;
  } else {
      fetti.physics.velocity -= fetti.physics.velocity * dragFriction;
  }

  fetti.physics.y += 3;
  fetti.physics.tiltAngle += fetti.physics.tiltAngleSpeed;
  var _fetti$physics = fetti.physics;
  var x = _fetti$physics.x;
  var y = _fetti$physics.y;
  var z = _fetti$physics.z;
  var tiltAngle = _fetti$physics.tiltAngle;
  var wobble = _fetti$physics.wobble;

  var wobbleX = x + 10 * Math.cos(wobble);
  var wobbleY = y + 10 * Math.sin(wobble);
  var transform = "translate3d(" + wobbleX + "px, " + wobbleY + "px, " + z + "px) rotate3d(1, 1, 1, " + tiltAngle + "rad)";
  fetti.element.style.visibility = "visible";
  fetti.element.style.transform = transform;
  fetti.element.style.opacity = 1 - progress;
  /* eslint-enable */
}

function animate(root, fettis, dragFriction, decay, duration, stagger) {
  var startTime = void 0;
  return new Promise(function(resolve) {
      function update(time) {
          if (!startTime) startTime = time;
          var elapsed = time - startTime;
          var progress = startTime === time ? 0 : (time - startTime) / duration;
          fettis.slice(0, Math.ceil(elapsed / stagger)).forEach(function(fetti) {
              updateFetti(fetti, progress, dragFriction, decay);
          });

          if (time - startTime < duration) {
              requestAnimationFrame(update);
          } else {
              fettis.forEach(function(fetti) {
                  if (fetti.element.parentNode === root) {
                      return root.removeChild(fetti.element);
                  }
              });
              resolve();
          }
      }

      requestAnimationFrame(update);
  });
}

var defaults4 = {
  angle: 90,
  spread: 45,
  startVelocity: 45,
  elementCount: 50,
  width: "4px",
  height: "4px",
  perspective: "",
  colors: defaultColors3,
  duration: 9000,
  stagger: 0,
  dragFriction: 0.7,
  random: Math.random,
};

function backwardPatch(config) {
  if (!config.stagger && config.delay) {
      config.stagger = config.delay;
  }

  return config;
}

window.throwConfetti = function(root) {
    //console.log('Root: ' + root); // For debugging
  if (!root) {
    console.error("Root element is not defined.");
    return;
  }
  var config = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var _Object$assign = Object.assign({}, defaults4, backwardPatch(config));

  var elementCount = _Object$assign.elementCount;
  var colors = _Object$assign.colors;
  var width = _Object$assign.width;
  var height = _Object$assign.height;
  var perspective = _Object$assign.perspective;
  var angle = _Object$assign.angle;
  var spread = _Object$assign.spread;
  var startVelocity = _Object$assign.startVelocity;
  var decay = _Object$assign.decay;
  var dragFriction = _Object$assign.dragFriction;
  var duration = _Object$assign.duration;
  var stagger = _Object$assign.stagger;
  var random = _Object$assign.random;

  root.style.perspective = perspective;
  var elements = createElements(root, elementCount, colors, width, height);
  var fettis = elements.map(function(element) {
      return {
          element: element,
          physics: randomPhysics(angle, spread, startVelocity, random),
      };
  });
  return animate(root, fettis, dragFriction, decay, duration, stagger);
};




var ImageHover = {
    init: function () {
        ImageHover.setupImages();
        ImageHover.bindEvents();
    },
    bindEvents: function () {
        $(".plp-product-standard .card-active:not(.plp-auto-hover)").each(function () {
            var hovered = $(this);
            var cycle;
            var timer;
            hovered.hover(
                function () {
                    hovered.addClass('hovering-card');
                    var thumbnailIndex = 0;
                    var thumbnailArray = hovered.find('.media').children().not(".product-image-color-overlay");
                    timer = setTimeout(function () {
                        thumbnailIndex++;
                        var $visible = thumbnailArray.eq(thumbnailIndex);
                        thumbnailArray.removeClass("image-active");
                        $visible.addClass("image-active");
                        cycle = setInterval(function () {
                            thumbnailIndex++;
                            if (thumbnailIndex === thumbnailArray.length) {
                                thumbnailIndex = 0;
                                thumbnailArray.removeClass("image-active");
                                thumbnailArray.eq(0).addClass("image-active");
                            } else {
                                var $visible = thumbnailArray.eq(thumbnailIndex);
                                thumbnailArray.removeClass("image-active");
                                $visible.addClass("image-active");
                            }
                        }, 1800);
                    }, 1300);
                },
                function () {
                    hovered.removeClass('hovering-card');
                    var thumbnailArray = hovered.find('.media').children().not(".product-image-color-overlay");
                    thumbnailArray.removeClass("image-active");
                    thumbnailArray.eq(0).addClass("image-active");
                    clearTimeout(timer);
                    clearInterval(cycle);
                }
            );
        });
    },
    setupImages: function () {
        var projectImage = $(".collection-container .product-card-canvas, .search-bar-item .product-card-canvas");
        projectImage.each(function () {
            $(this).find(".product-card-image:eq(0)").addClass("image-active");
        });
        var projectHomeImage = $(".hp-products-grid.grid.grid-uniform.hp-pillar .product-card-canvas");
        projectHomeImage.each(function () {
            $(this).find(".product-card-image:eq(0)").addClass("image-active");
        });
        $("li.nav-list-level-1-item.desktop-navbar-nav-dropdown.dropdown").on("mouseenter", function () {
            var projectImage1 = $(".desktop-navbar-nav-dropdown-menu.dropdown-menu .product-card-canvas");
            projectImage1.each(function () {
                $(this).find(".product-card-image:eq(0)").addClass("image-active");
            });
        });
        $(".desktop-navbar").on("mouseleave", function () {
            var projectImage2 = $(".desktop-navbar-nav-dropdown-menu.dropdown-menu .product-card-canvas, .search-bar-result .product-card-canvas");
            projectImage2.each(function () {
                $(this).find(".product-card-image:eq(0)").removeClass("image-active");
            });
        });
    }
};



function autoplayPLPVideos() {
    // Detecting if the device is mobile or not
    const isMobile = window.innerWidth <= 768; // Adjust width as per your requirement
  
    // Select the appropriate videos based on the device type
    const selector = isMobile ? '.plp-video.krw--mobile-only' : '.plp-video.krw--desktop-only';
    const videos = document.querySelectorAll(selector);
  
    // Check if there are any videos on the page
    if (videos.length === 0) {
      //console.log('No videos found for the current device type.');
      return; // Exit the function if no videos are found
    }
  
    videos.forEach(video => {
      // Get the source element and the data-src attribute
      const source = video.querySelector('source');
      const videoSrc = source.getAttribute('data-src');
  
      if (videoSrc) {
        // Set the src attribute from data-src
        source.src = videoSrc;
  
        // Load and play the video
        video.load();
        video.play().catch(e => console.error('Error trying to play the video:', e));
      }
    });
  }



function autoImageHover(productHoverHandle) {
    // On click of plus icon add class to product parent
    var slideThroughImages;

   // console.log('Found item to hover: ' + productHoverHandle);



    // For mobile active sliding through images of clicked product
    function toggleActiveProductImage() {


        var next = $('.plp-auto-hover[data-frame-handle="' + productHoverHandle + '"]').find('.image-active').next('.product-desktop-image');
        // If not foudn, then retrieve the first one in the list
        if (!next.length) next = $('.plp-auto-hover[data-frame-handle="' + productHoverHandle + '"]').find('.image_1');
        // Remove ".show", and hide the current <li>
        $('.plp-auto-hover[data-frame-handle="' + productHoverHandle + '"]').find('.image-active').removeClass('image-active');
        // Add ".show" and show next <li>
        next.addClass('image-active');

        if ($('.plp-auto-hover[data-frame-handle="' + productHoverHandle + '"]').find('.image_2:not(.last--image)').hasClass('image-active')) {
            clearTimeout(slideThroughImages);

            setTimeout(function () {
                slideThroughImages = setInterval(function () {
                    toggleActiveProductImage();
                }, 1700);
            }, 4000);

        }


    };

    slideThroughImages = setInterval(function () {
        toggleActiveProductImage();
    }, 1700);






    // On Scroll hide active bag



};

window.addEventListener('load', (event) => {
    $('.plp-auto-hover').each(function () {
        var productHoverHandle = $(this).data('frame-handle');
        autoImageHover(productHoverHandle);
    });
});


if (!isMobile) {
    ImageHover.init();
}

function loadJSONcollection(familyCollectionHandle, $visibleLazyProduct) {

    $.ajax({
            url: '/collections/' + familyCollectionHandle + '?view=family',
            type: 'GET'
        })
        .done(function (data) {
            $visibleLazyProduct.find('.plp-grid-items-wrapper').append(data);
        })
        .fail(function (data) {})
        .always(function (data) {});
}

const $windowHeight = $(window).height();

var LoadFamily = {
    init: function () {
        LoadFamily.bindEvents();
    },
    bindEvents: function () {
        $.fn.elementInViewport = function () {
            let elementTop = $(this).offset().top - 700;
            let elementBottom = elementTop + $(this).outerHeight();
            let viewportTop = $(window).scrollTop();
            let viewportBottom = viewportTop + $windowHeight;
            return elementBottom > viewportTop && elementTop < viewportBottom;
        };

        const debounce = (callback, wait) => {
            let timeoutId = null;
            return (...args) => {
                window.clearTimeout(timeoutId);
                timeoutId = window.setTimeout(() => {
                    callback.apply(null, args);
                }, wait);
            };
        }

        // Do stuff with the event!
        $(".plp-product-card").each(function () {
            let $visibleLazyProduct = $(this);
            let $visibleLazyProductHTML = $(this).html();
            let familyCollectionHandle = $visibleLazyProduct.data('family-handle');
            let mainProductHandle = $visibleLazyProduct.data('product-handle');
            let familyCollectionURL = '/collections/' + familyCollectionHandle + '?view=family';



            const scrollItemIntoViewPort = debounce((ev) => {
                // Do stuff with the event!


                if ($visibleLazyProduct.elementInViewport()) {
                    if (!$visibleLazyProduct.hasClass('plp-family-loaded')) {
                        loadJSONcollection(familyCollectionHandle, $visibleLazyProduct);
                    }

                }

                if ($visibleLazyProduct.elementInViewport()) {
                    $visibleLazyProduct.addClass('plp-family-loaded');
                    $visibleLazyProduct.find('.loaded-item[data-frame-handle="' + mainProductHandle + '"]').remove();

                }



            }, 0000);




            window.addEventListener('scroll', scrollItemIntoViewPort);
        });


    }
};

var plpSwatchHover = {
    init: function () {
        plpSwatchHover.bindEvents();
    },
    bindEvents: function () {

        var familyItemHover;
        $(".family-swatch-product a").hover(
            function () {
                var $this = $(this);
                var $card = $this.parents('.grid__item');
                var hoveredItemHandle = $this.data('product-handle');

                familyItemHover = setTimeout(function () {
                    let $cardReviews = $card.find('.card-active').find('.pwr-category-snippets');
                    // console.log($cardReviews);
                    $card.find('.frame-active').removeClass('frame-active');
                    $this.parents('.family-swatch').addClass('frame-active');
                    $card.find('.card-active').removeClass('card-active');
                    $card.find('.card-wrapper[data-frame-handle="' + hoveredItemHandle + '"]').addClass('card-active').attr('aria-hidden', 'true');
                    $('main .card-wrapper[data-frame-handle="' + hoveredItemHandle + '"] .product-card-details').append($cardReviews).attr('aria-hidden', 'false');
                    ImageHover.init();
                }, 200);
            },
            function () {
                clearTimeout(familyItemHover);
            }
        );
    }
}






onload = (event) => {

    if ($(window).width() > 990) {
        plpSwatchHover.init();
    }
    //LoadFamily.init();
    

};

const originalCollectionURL = $('.collection-filter-groups').attr('data-collection-url');


let pagination_template_name = 'ajax-pagination';

if ($('body').hasClass('template-collection-brand-blocks-main')) {
    pagination_template_name = 'ajax-pagination-carousels'
}

document.addEventListener('DOMContentLoaded', function() {
   
    // Your code goes here
    //console.log("DOM fully loaded and parsed");
    // You can call other functions here
    // For example, if you have a function named 'initializePage'
    autoplayPLPVideos();
});



var paginationIsLoading = !1;
(function () {

    $(document).on("click", ".js-pagination-load-more", function (event) {
        event.preventDefault();
        var $ajaxWrapper = $("#load-more-dump #product-grid");
        var ajaxURL = $(this).attr("href");

        // console.log('Ajax page URL: ' + ajaxURL);
        $.ajax({
            url: ajaxURL + '&view=' + pagination_template_name,
            dataType: "html",
            beforeSend: function () {
                $(".spinner-gif").show();
            },
        }).done(function (data) {
            // check class added
            $(".spinner-gif").hide();
            var $pagination = $(data).find(".pagination-load-more");
            $(".pagination-load-more-wrapper").html($pagination);
            setTimeout(function () {
                if ($(window).width() > 990) {
                    plpSwatchHover.init();
                    ImageHover.init();
                }
                $(function (event) {
                    if (window._swat) {
                        var swymDataElems = $("body").find("script.swym-product-view-snippet");
                        $(swymDataElems).appendTo(document.body);
                        setTimeout(function () {
                            window._swat.initializeActionButtons(".load-more-target");
                        }, 1000);
                    }
                });

            }, 0500);
            var ajaxURLNext = $(".pagination-load-more").attr("href");
            if (!ajaxURLNext) {
                $(".pagination-load-more-wrapper").remove();
                $("body").addClass("collection-last-page-loaded");
                $(".pe--load-more").addClass("pe--show-button");
            }
            var $items = $(data).find("#load-more-dump #product-grid").children();
            $items.css("opacity", "0").addClass('current-page').prev('.current-page').removeClass('current-page');



            $ajaxWrapper.append($items);

            if ($('#load-more-dump').attr('data-brand-blocks-count') == 4) {
                //$items.find('.product--block').slice().addClass('hidden-last-product');
            }

            if ($('#load-more-dump').attr('data-brand-blocks-count') == 6) {
                $items.find('.product--block').slice(-2).addClass('hidden-last-product');
            }

            $items.prev('.current-page').find('.hidden-last-product').clone().prependTo($items);

            $items.prev('.current-page').removeClass('current-page').addClass('previous-page');

            $items.animate({
                opacity: "1"
            }, 400);

           

            
            paginationIsLoading = !1;
        });
    });
    if ($(".pagination-style-scroll").length) {
        $(window).on(
            "scroll",
            _.throttle(
                function () {
                    var limit = 3 * $(window).height();
                    if ($(document).height() - $(window).scrollTop() < limit) {
                        if (!paginationIsLoading) {
                            paginationIsLoading = !0;
                            $(".pagination-load-more").trigger("click");

                            //console.log('Loading');
                        }
                    }
                },
                250, {
                    leading: !0,
                    trailing: !0
                }
            )
        );
    }
})();

function updateCarousels() {
    //console.log('updateCarousels called');
    document.querySelectorAll('main .plp-carousel').forEach((carousel) => {
        const carouselId = carousel.dataset.carouselId;
        const slides = Array.from(carousel.querySelectorAll('img')); // Create an array of slides
        const track = document.querySelector(`main .carousel-track-wrapper[data-carousel-id="${carouselId}"] .carousel-track`);
        const rectangle = track.querySelector('.carousel-rectangle');

        rectangle.style.width = `${track.offsetWidth / slides.length}px`;

        const trackWidth = track.offsetWidth - rectangle.offsetWidth;

        carousel.addEventListener('scroll', () => {
            const scrollLeft = carousel.scrollLeft;
            const scrollWidth = carousel.scrollWidth;
            const carouselWidth = carousel.offsetWidth;
            const scrollPercent = scrollLeft / (scrollWidth - carouselWidth);

            rectangle.style.transform = `translateX(${scrollPercent * trackWidth}px)`;

        });
    });
}


function ajaxLoadElements() {

    setTimeout(function () {





        if ($(window).width() > 990) {
            plpSwatchHover.init();

            const familySwatchBars = document.querySelectorAll('.family-products-swatch-bar');

            if (familySwatchBars.length > 0) {
                familySwatchBars.forEach((swatchBar) => {
                    const swatches = swatchBar.querySelector('.family-swatches');
                    const swatchItems = swatches.querySelectorAll('.family-swatch-product');
                    const plusSign = swatchBar.querySelector('.family-swatch.family-plus');

                    if (swatchItems.length > 6 && plusSign) {
                        swatches.insertBefore(plusSign, swatchItems[6]);
                    }
                });
            }
            //LoadFamily.init();

            ImageHover.init();
        } else {
            
        }

        var ajaxURLNext = $(".pagination-load-more").attr("href");
        if (!ajaxURLNext) {
            $(".pagination-load-more-wrapper").remove();
            $("body").addClass("collection-last-page-loaded");
            $(".pe--load-more").addClass("pe--show-button");
        }

        $(document).on('click', 'a.product-card-plus', function (event) {
            var $this = $(this);

            event.preventDefault();
            $this.parents('.product-card').find('.product-card-function-bar').removeClass('hovering-plus');


        });



        var plusHoverTimer;
        $('a.product-card-plus').hover(function () {
            var $this = $(this);
            plusHoverTimer = setTimeout(function () {
                $this.parents('.product-card').find('.product-card-function-bar').addClass('hovering-plus');

            }, 0300);
        }, function () {
            clearTimeout(plusHoverTimer);

        });

    }, 0500);





}


$(document).on('click', '.filter-toggle', function () {
    var $this = $(this);

    if (!$('body').hasClass('gift-collection')) {
    if ($this.parent().hasClass('filter-opened')) {

        $this.find('.filters-toggle-icon span:not(.filters-toggle-icon-text)').text('CLOSE');
    } else {
        if ($(window).width() > 990) {
            $this.find('.filters-toggle-icon span:not(.filters-toggle-icon-text)').html('<img src="//cdn.shopify.com/s/files/1/2422/6603/t/441/assets/filter-icon.png?v=135418418679922801741650399980" role="presentation" alt="Filters">');
        } else {
            $this.find('.filters-toggle-icon span:not(.filters-toggle-icon-text)').text('FILTER');
        }
    }
    }


    $this.parent().toggleClass('filter-opened');




});

const filter_rail = document.querySelectorAll('[body-scroll-lock-ignore]');

$('.filters-toggle-btn').on('click', function () {

    var $this = $(this);
    if (!$('body').hasClass('gift-collection')) {
    if ($this.parents('.collection-refinement').hasClass('showing-filters')) {
        $this.find('.filters-toggle-icon span').text('FILTER');

        if ($(window).width() > 990) {
            $this.find('.filters-toggle-icon span').html('<img src="//cdn.shopify.com/s/files/1/2422/6603/t/441/assets/filter-icon.png?v=135418418679922801741650399980" role="presentation" alt="Filters">');
        } else {
            $this.find('.filters-toggle-icon span').text('FILTER');
        }


    } else {
        $this.find('.filters-toggle-icon span').text('CLOSE');





    }
}

    if (!$('.collection-refinement').hasClass('filter-is-selected')) {
        $('.filters-bar').toggleClass('show-filters-bar');
    }


    $('.collection-filter-groups').toggleClass('show-filters');
    $('.collection-refinement').toggleClass('showing-filters');

    $('body').toggleClass('collection-filters-showing');

});

function attachMarkYourCalendarEvents() {
    // Get elements
    const tooltipPopup = document.querySelector('.tooltip-popup');
    const parentContainer = document.querySelector('.mark-your-calendar-brand-block');
    const markYourCalendar = document.querySelector('.mark-your-calendar');

    // Function to toggle show-tooltip-popup class on tooltip popup and show tooltip at clicked coordinates
    function toggleTooltipPopup(event) {
       // console.log('Toggling show-tooltip-popup class on tooltip popup');
        const x = event.clientX - parentContainer.offsetLeft;
        const y = event.clientY - parentContainer.offsetTop;
        tooltipPopup.style.position = 'absolute';
        tooltipPopup.style.left = x + 'px';
        tooltipPopup.style.top = y + 'px';
        tooltipPopup.classList.toggle('show-tooltip-popup');
    }

    // Add click event listener to mark-your-calendar element
    markYourCalendar.addEventListener('click', (event) => {
       // console.log('Mark your calendar clicked');
        toggleTooltipPopup(event);
    });

    // Add event listener to tooltipPopup to prevent click events from propagating up to the document
    tooltipPopup.addEventListener('click', (event) => {
        if (event.target.closest('.calendar-link')) {
           // console.log('Calendar link clicked');
            // The default behavior of the link click event will occur without the 'return' statement.
        }
        event.stopPropagation();
    });

    // Add scroll event listener to hide tooltip popup
    document.addEventListener('scroll', () => {
       // console.log('Scrolling outside of tooltip');
        tooltipPopup.classList.remove('show-tooltip-popup');
    });

    // Add click event listener to hide tooltip popup
    document.addEventListener('click', (event) => {
        if (!parentContainer.contains(event.target)) {
            //console.log('Clicked outside of tooltip');
            tooltipPopup.classList.remove('show-tooltip-popup');
        }
    });
}

// Call the attachMarkYourCalendarEvents function on document ready
if ($('.mark-your-calendar-brand-block').length) {
    document.addEventListener('DOMContentLoaded', () => {
        attachMarkYourCalendarEvents();
    });
}
const cssClasses = {
    collectionSidebar: '.collection-sidebar',
    accordionHeading: '.filter-group:not(.sort-group)',
    accordionContent: '.accordion-content',
    filterItem: '.Linklist__Item:not(.sort-item)',
    sortItem: '.Linklist__Item.sort-item',
    filter: '.Linklist:not(.sort-list)',
};

// Accordion
const accordionHeading = $(cssClasses.accordionHeading);

var destroyButton = document.getElementById('destroy');
document.addEventListener("DOMContentLoaded", function () {
    ajaxLoadElements();
});

accordionHeading.on('click', function () {
    const parentItem = $(this).parent();
    const content = parentItem.find(cssClasses.accordionContent).first();

    $(this).toggleClass('open');
    content.slideToggle();
});

// Tag filter
const url = window.location.origin + window.location.pathname;
const filterItem = $(cssClasses.filterItem);
let collectionUrl = $(cssClasses.collectionSidebar).data('collection-url');

const productsContainer = $('#ProductGridContainer #product-grid');

filterItem.each(function () {
    const tag = $(this).data('tag');

    if (url.indexOf(tag) !== -1) {
        $(this).addClass('is-selected');

      //  console.log($(this), 'add class is-selected');

        const accordionHeading = $(this).parent().parent().find(cssClasses.accordionHeading);

        if (accordionHeading.length !== 0) {
            accordionHeading.trigger('click');
        }
    }
});

function checkNumberOfAdditionalProducts() {

    let $this = $('.get-more-products');

    function getLastPartOfUrl(url) {
        const urlParts = url.split('/');
        return urlParts[urlParts.length - 1];
    }

    const currentUrlPath = window.location.pathname;
    const lastPart = getLastPartOfUrl(currentUrlPath);

    var seeMoreCollectionHandle = $this.attr('data-collection-handle-to-get');

    $.get({
        url: "/collections/" + seeMoreCollectionHandle + "/" + lastPart + '?view=filtering-count',
        success: function (data) {
            setTimeout(function () {

                var numberOfProducts = $(data).find("#product-grid").attr('data-products-count');

                $this.text('See ' + data + ' More');

                $this.addClass('show-get-more');

            }, 0100);
        }
    });

}

if (!$('.checkNumberOfAdditionalProducts').hasClass('hidden-get-more') && $('body').hasClass('template-name-collection')) {
    checkNumberOfAdditionalProducts();
}

let filtering_template_name = 'filtering';

if ($('body').hasClass('template-collection-brand-blocks-main')) {
    filtering_template_name = 'filtering-carousels'
}

$(document).on('click', '.Linklist__Item:not(.sort-item)', function () {
    collectionUrl = $('.collection-filter-groups').attr('data-collection-url');


    let search = window.location.search;

    if (search.indexOf('page') !== -1) {
        const pageParam = search.split("&")[0];
        search = search.replace(pageParam, '').replace('&', '?');
    }

    $('.filtered--count').text('');
    $('.filtered-loading').css('display', 'block');
    if ($(window).width() > 834 && $(window).scrollTop() != 0) {
        $("html, body").animate({
            scrollTop: 62
        }, 500);
    }

    if ($(window).width() < 834) {
        $("html, body").scrollTop(0);
    }



    const filter = $(this).parents('[data-filter]');
    const filterItems = filter.find(cssClasses.filterItem);
    /* var addActiveClass = true;
     if ($(this).hasClass('active')) {
         addActiveClass = false
     }
     filterItems.removeClass('active');
     if (addActiveClass) {
         $(this).addClass('active');
     }*/

    if ($(this).hasClass('is-selected')) {

    } else {

    }

    const tag_custom_name = $(this).attr('data-tag-add-on');

    $(this).toggleClass('is-selected').siblings().removeClass('is-selected');

    if (tag_custom_name != "false") {
        $(this).parents('.filter-group').find('.filter-toggle em').text(' ' + tag_custom_name)
    } else {
       $(this).parents('.filter-group').find('.filter-toggle em').text(' ' + $(this).attr('data-gtm-label'));
    }

    if (!$(this).parents('.filter-group').find('.is-selected').length) {
        $(this).parents('.filter-group').find('.filter-toggle em').text('');
    }

  
    var activeItems = $('.collection-filter-groups').find(cssClasses.filterItem + '.is-selected');
    var activeTags = [];

    activeItems.each(function (index, el) {
        var tag = $(el).attr('data-tag');

        if (tag) {
            activeTags.push(tag);
        }
    });

    var tagsUrl = activeTags.join('+');

    var newUrl = collectionUrl;

    if (tagsUrl) {
        newUrl += '/' + tagsUrl;
    }
    newUrl += search;
    // console.log(newUrl);
    // console.log('---');
    $('.collection-container').addClass('ajax-loading');
    $('.collection-filter-groups-inner').addClass('filtered-products-loading');

    var newUrlRequest = newUrl;

    if (newUrlRequest.indexOf('?') > -1) {
        // If URL already contains a "?" character, append the new parameter using "&"
        newUrlRequest += '&view=' + filtering_template_name;
    } else {
        // If URL does not contain a "?" character, append the new parameter using "?"
        newUrlRequest += '?view=' + filtering_template_name;
    }

    var filteredCollectionURL = $('.collection-filter-groups').attr('data-collection-url');

    $.get({
        url: newUrlRequest,
        success: function (data) {
            setTimeout(function () {
                $('.filters-bar').addClass('show-filters-bar');
                var newProductsWrapper = $(data).find("#product-grid");
                var newPagination = $(data).find(".pagination");
                var newPaginationHtml = newPagination.html();
                var newProductsHtml = newProductsWrapper.html();
                var newItemCount = newProductsWrapper.attr('data-products-count');
                if (newProductsHtml) {
                    productsContainer.html(newProductsHtml);
                   // console.log('Products found');
                } else {

                    let emptyCollection = $(data).find('#emptyCollection');
                    let emptyCollectionHTML = emptyCollection.html();
                   // console.log('no products found');

                    $('.pe--load-more').css('display', 'none');

                    productsContainer.empty();

                    if (emptyCollectionHTML) {
                        productsContainer.append(emptyCollectionHTML);
                    } else {
                      //  console.log('no products message found');
                        productsContainer.append('<div class="title-wrapper center"><h2 class="title title--primary">Oops, you stumped Santa!<br><a href="{{ collection.url }}" class="underlined-link link clear-all-link">Clear all</a> or select different options.</h2></div>');
                    }
                }



                if ($('.main-filter[data-tag="lens_polarized"]').hasClass('is-selected')) {

                    $('body').addClass('polarized-filter-selected');

                } else {
                    $('body').removeClass('polarized-filter-selected');
                }

                if ($('.main-filter.is-selected').length) {
                    $('body').addClass('plp--hide-brand-blocks');
                } else {
                    $('body').removeClass('plp--hide-brand-blocks');
                }


                $('.filtered-loading').css('display', 'none');
                $('.collection-filter-groups-inner').removeClass('filtered-products-loading');
                if (newItemCount) {
                    if ($('body').hasClass('gift-collection')) {
                        $('.filter-groups-header .filtered--count').text(newItemCount + " Gifts");
                    } else {
                        $('.filter-groups-header .filtered--count').text(newItemCount + " Frames");
                    }
                } else {
                    newItemCount = 0;
                    if ($('body').hasClass('gift-collection')) {
                        $('.filter-groups-header .filtered--count').text("0 Gifts");
                    } else {
                        $('.filter-groups-header .filtered--count').text("0 Frames");
                    }
                }
                $('.collection-grid__products').attr('data-products-count', newItemCount);

                setTimeout(function () {
                    if (newItemCount < 6) {
                        if (newItemCount == 0) {
                            $('.get-more-products').addClass('hidden-get-more');
                        } else {
                            $('.pe--load-next-collection-wrapper').addClass('disable-collection-load');
                            $('.pe--load-more.pe--show-button').css('display', 'none');
                            if (filteredCollectionURL != '/collections/pre-shop' && filteredCollectionURL != '/collections/sale') {
                                $('.get-more-products').removeClass('hidden-get-more');
                            }
                          //  console.log('Less than 6 products');
                            setTimeout(function () {
                                checkNumberOfAdditionalProducts();
                            }, 0100);
                            $("html, body").scrollTop(0);
                        }
                    } else {
                       // console.log('More than 6 products. Number of products: ' + newItemCount);
                        $('.pe--load-next-collection-wrapper').removeClass('disable-collection-load');
                        $('.pe--load-more.pe--show-button').css('display', 'block');
                        $('.get-more-products').addClass('hidden-get-more');
                    }
                }, 0300);

                paginationIsLoading = !1;

                ajaxLoadElements();
                if ($('.mark-your-calendar-brand-block').length) {
                    attachMarkYourCalendarEvents();
                }
                setTimeout(function () {
                    if ($('.collection-grid__products').attr('data-products-count') > 49) {
                        $('.pagination').remove();
                        newPagination.insertAfter('#load-more-dump');
                      //  console.log('More than 49 products');
                        $('body').removeClass('collection-last-page-loaded');
                        $('.pe--load-more').removeClass('pe--show-button');
                        $('.spinner-gif').show();
                    }

                    if ($('.collection-grid__products').attr('data-products-count') < 50) {
                        $('.pagination').remove();
                        //console.log('Less than 50');
                        $('body').addClass('collection-last-page-loaded');
                        $('.pe--load-more').removeClass('pe--show-button');
                    }

                    if ($('.main-filter.is-selected').length) {

                        $('.collection-refinement').addClass('filter-is-selected');

                    } else {
                        $('.collection-refinement').addClass('filter-is-selected');
                    }
                }, 0500);
                history.pushState({
                    page: newUrl
                }, null, newUrl);
                $('.collection-container').removeClass('ajax-loading');
                //fetchReviews(newUrlRequest);
            }, 0500);
        }
    });
});

$(document).on('click', '.filter-clear-all, .clear-all-link', function (e) {
    e.preventDefault();
    var mainURL = originalCollectionURL;
    if ($('.holiday-filter-nav').length) {
        mainURL = $('.is-selected').attr('data-tag');
    }
    $('.filtered--count').text('');
    $('.filtered-loading').css('display', 'block');
    if ($(window).width() > 834 && $(window).scrollTop() != 0) {
        $("html, body").animate({
            scrollTop: 62
        }, 500);
    } else {
        $("html, body").scrollTop(0);
    }

    $('.filter-toggle em').text('');

    $('.collection-filter-groups-inner').addClass('filtered-products-loading');

    $('.Linklist__Item').removeClass('is-selected');

    $('body').removeClass('polarized-filter-selected');
    

    $('.collection-container').addClass('ajax-loading');
    $('.collection-filter-groups-inner').addClass('filtered-products-loading');


    $.get({
        url: mainURL + '?view=' + filtering_template_name,
        success: function (data) {
           // console.log('Got all products!');
            $('.filters-bar').addClass('show-filters-bar');
            setTimeout(function () {
                var newProductsWrapper = $(data).find("#product-grid");
                var newPagination = $(data).find(".pagination");
                var newPaginationHtml = newPagination.html();
                var newProductsHtml = newProductsWrapper.html();
                var newItemCount = newProductsWrapper.attr('data-products-count');
                productsContainer.html(newProductsHtml);
                $('.collection-filter-groups').attr('data-collection-url', originalCollectionURL);
                var newItemCount = newProductsWrapper.attr('data-products-count');
                $('.filtered-loading').css('display', 'none');
                $('.collection-filter-groups-inner').removeClass('filtered-products-loading');
                if (newItemCount) {
                    if ($('body').hasClass('gift-collection')) {
                        $('.filter-groups-header .filtered--count').text(newItemCount + " Gifts");
                    } else {
                        $('.filter-groups-header .filtered--count').text(newItemCount + " Frames");
                    }
                } else {
                    if ($('body').hasClass('gift-collection')) {
                        $('.filter-groups-header .filtered--count').text("0 Gifts");
                    } else {
                        $('.filter-groups-header .filtered--count').text("0 Frames");
                    }
                }
                $('.collection-grid__products').attr('data-products-count', newItemCount);

                $('.filters-bar').removeClass('show-filters-bar');

                $('body').removeClass('plp--hide-brand-blocks');

                $('.sort-option').removeClass('is-selected');

               // console.log('filter product count' + newItemCount);
                setTimeout(function () {
                    if (newItemCount) {
                        if (newItemCount < 6) {
                            $('.pe--load-next-collection-wrapper').addClass('disable-collection-load');
                            $('.pe--load-more.pe--show-button').css('display', 'none');
                            $('.get-more-products').removeClass('hidden-get-more');
                        } else {
                            $('.pe--load-next-collection-wrapper').removeClass('disable-collection-load');
                            $('.pe--load-more.pe--show-button').css('display', 'block');
                            $('.get-more-products').addClass('hidden-get-more');
                        }
                    } else {
                        $('.pe--load-more').css('display', 'none');
                    }

                    if ($('.main-filter.is-selected').length) {
                        $('.collection-refinement').addClass('filter-is-selected');
                    } else {
                        $('.collection-refinement').addClass('filter-is-selected');
                    }

                    if ($(window).width() < 991) {
                        $("#product-grid .card-brand-block").each(function (i) {
                            $(this).addClass("editorial--block-" + (i + 1));
                        });
                        $(".plp-product-standard").each(function (i) {
                            $(this).addClass("product--block-" + (i + 1));
                        });

                        $(".editorial--block-1").insertAfter(".product--block-4");

                        if ($("body").hasClass("sale-area")) {
                             $(".editorial--block-2").insertAfter(".product--block-12");

      $(".editorial--block-3").insertAfter(".product--block-20");

      $(".editorial--block-4").insertAfter(".product--block-28");

      $(".editorial--block-5").insertAfter(".product--block-36");

      $(".editorial--block-6").insertAfter(".product--block-44");

      $(".editorial--block-7").insertAfter(".product--block-52");
                        }
                    }
                }, 0300);

                paginationIsLoading = !1;
                ajaxLoadElements();

                if ($('.mark-your-calendar-brand-block').length) {
                    attachMarkYourCalendarEvents();
                }
                setTimeout(function () {
                    if ($('.collection-grid__products').attr('data-products-count') > 49) {
                        $('.pagination').remove();
                        newPagination.insertAfter('#load-more-dump');

                      //  console.log('More than 24 products');
                        $('body').removeClass('collection-last-page-loaded');
                        $('.pe--load-more').removeClass('pe--show-button');
                        $('.spinner-gif').show();
                    }

                    if ($('.collection-grid__products').attr('data-products-count') < 50) {
                        $('.pagination').remove();
                       // console.log('Less than 24');
                        $('body').addClass('collection-last-page-loaded');
                        $('.pe--load-more').addClass('pe--show-button');
                    }

                    if ($('.main-filter.is-selected').length) {

                        $('.collection-refinement').addClass('filter-is-selected');

                    } else {
                        $('.collection-refinement').addClass('filter-is-selected');
                    }
                }, 0500);
                history.pushState({
                    page: mainURL
                }, null, mainURL);
                $('.collection-container').removeClass('ajax-loading');
                $('.hide-product-counter').removeClass('hide-product-counter');
               // fetchReviews(mainURL);
            }, 0500);
        }
    });
});

$(document).on('click', '.sort-option', function () {

    var $this = $(this);
    var value = $this.attr('data-value');
    var url = window.location.href;
    var arr = url.split('?');



    $this.parents('li').toggleClass('is-selected').siblings().removeClass('is-selected');
    $('.sort-option').removeClass('is-selected');
    setTimeout(function () {
        $this.addClass('is-selected');
    }, 0100);

    $('.filtered--count').text('');
    $('.filtered-loading').css('display', 'block');

    // Get all URL parameters
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    var sort_by = getUrlParameter('sort_by');

    var newSorting;

    if (sort_by != '') {
        var currentUrl = window.location.href;
        var url2 = new URL(currentUrl);
        url2.searchParams.set("sort_by", value); // setting your param
        newSorting = url2.href;

    } else {
        newSorting = window.location.href + "?sort_by=" + value;
    }
    //  console.log(newSorting);

    $('.collection-filter-groups-inner').addClass('filtered-products-loading');

    //  console.log(newSorting+'&view='+filtering_template_name);

    $.get({
        url: newSorting,
        success: function (data) {

            $('body').addClass('plp--hide-brand-blocks');

            $('.filters-bar').addClass('show-filters-bar');
            var newProductsWrapper = $(data).find("#product-grid");
            var newPagination = $(data).find(".pagination");
            var newPaginationHtml = newPagination.html();
            var newProductsHtml = newProductsWrapper.html();
            var newItemCount = newProductsWrapper.attr('data-products-count');

            productsContainer.html(newProductsHtml);
           // console.log('Products found');

            var newItemCount = newProductsWrapper.attr('data-products-count');
            if ($('body').hasClass('gift-collection')) {
                $('.filter-groups-header .filtered--count').text(newItemCount + " Gifts");
            } else {
                $('.filter-groups-header .filtered--count').text(newItemCount + " Frames");
            }
            $('.filtered-loading').css('display', 'none');
            $('.collection-filter-groups-inner').removeClass('filtered-products-loading');


            var newPaginationHtml = $(data).find("#AjaxinatePagination").html();
            $('#AjaxinatePagination').html(newPaginationHtml);
            var pagination = $("#AjaxinatePagination");

            ajaxLoadElements();

            if ($('.mark-your-calendar-brand-block').length) {
                attachMarkYourCalendarEvents();
            }

            setTimeout(function () {
                if (newProductsWrapper.attr('data-products-count') > 24) {

                   // console.log('More than 24 products');

                    $('.pagination').remove();
                    newPagination.insertAfter('#load-more-dump');

                    $('body').removeClass('collection-last-page-loaded');
                    $('.pe--load-more').removeClass('pe--show-button');
                }

                if (newProductsWrapper.attr('data-products-count') < 25) {
                  //  console.log('Less than 24');
                    $('body').addClass('collection-last-page-loaded');
                    $('.pe--load-more').addClass('pe--show-button');
                    $('.pagination').remove();
                }

                if ($('.main-filter.is-selected').length) {

                    $('.collection-refinement').addClass('filter-is-selected');

                } else {
                    $('.collection-refinement').addClass('filter-is-selected');
                }
            }, 0500);



            history.pushState({
                page: newSorting
            }, null, newSorting);

            $('.collection-container').removeClass('ajax-loading');
           // fetchReviews(newSorting);
        }
    });
});

$(document).ready(function () {

    var getSortUrlParameter = function getSortUrlParameter(sortParam) {
        var sortPageURL = window.location.search.substring(1),
            sortURLVariables = sortPageURL.split('&'),
            sortParameterName,
            i;

        for (i = 0; i < sortURLVariables.length; i++) {
            sortParameterName = sortURLVariables[i].split('=');

            if (sortParameterName[0] === sortParam) {
                return typeof sortParameterName[1] === undefined ? true : decodeURIComponent(sortParameterName[1]);
            }
        }
        return false;
    };


    var sortBy = getSortUrlParameter('sort_by');


    $('.sort-option[data-value="' + sortBy + '"]').parents('li').addClass('is-selected');
    $('.sort-option[data-value="' + sortBy + '"]').addClass('is-selected');

    $(document).on('click', '.filters-overlay', function () {
        var $this = $(this);
        if (!$('body').hasClass('gift-collection')) {
            if ($this.parents('.collection-refinement').hasClass('showing-filters')) {
                $this.parents('.collection-refinement').find('.filters-toggle-icon span').text('FILTER');

                if ($(window).width() > 990) {
                    $this.parents('.collection-refinement').find('.filters-toggle-icon span').html('<img src="//cdn.shopify.com/s/files/1/2422/6603/t/441/assets/filter-icon.png?v=135418418679922801741650399980" role="presentation" alt="Filters">');
                } else {
                    $this.parents('.collection-refinement').find('.filters-toggle-icon span').text('FILTER');
                }


            } else {
                $this.parents('.collection-refinement').find('.filters-toggle-icon span').text('CLOSE');





            }
        }

        if (!$('.collection-refinement').hasClass('filter-is-selected')) {
            $('.filters-bar').toggleClass('show-filters-bar');
        }


        $('.collection-filter-groups').toggleClass('show-filters');
        $('.collection-refinement').toggleClass('showing-filters');

        $('body').toggleClass('collection-filters-showing');
    });




});

$(document).on("click", ".view-size-toggle", function () {
    $("body").toggleClass("large-product-view");
});

$(document).on('click', '.get-more-products', function () {
    var $this = $(this);

    $this.text('Loading...');



    function getLastPartOfUrl(url) {
        const urlParts = url.split('/');
        return urlParts[urlParts.length - 1];
    }

    const currentUrlPath = window.location.pathname;
    const lastPart = getLastPartOfUrl(currentUrlPath);

    var seeMoreCollectionHandle = $this.attr('data-collection-handle-to-get');

    var existingProductHandles = [];
    $('#load-more-dump #product-grid li[data-product-handle]').each(function () {
        existingProductHandles.push($(this).data('product-handle'));
    });



    let get_more_request_url = "/collections/" + seeMoreCollectionHandle + "/" + lastPart + "?view=" + filtering_template_name;
    let view_url = "/collections/" + seeMoreCollectionHandle + "/" + lastPart;

    $.get({
        url: get_more_request_url,
        success: function (data) {

            $('.collection-filter-groups').attr('data-collection-url', '/collections/all-styles');


            setTimeout(function () {

                var newCounter = $(data).find('#product-grid').attr('data-products-count');
                if ($('body').hasClass('gift-collection')) {
                    $('.filtered--count').text(newCounter + ' Gifts');
                } else {
                    $('.filtered--count').text(newCounter + ' Frames');
                }


                var newProductsWrapper = $(data).find("#product-grid");


                newProductsWrapper.find('li[data-product-handle]').each(function () {
                    var productHandle = $(this).data('product-handle');



                    if ($.inArray(productHandle, existingProductHandles) === -1) {
                        $('#load-more-dump #product-grid').append($(this));
                        existingProductHandles.push(productHandle);
                    }
                });

                paginationIsLoading = !1;
                ajaxLoadElements();
                $('.collection-container').removeClass('ajax-loading');
                $('.get-more-products').addClass('hidden-get-more');
                $('.pe--load-next-collection-wrapper').removeClass('disable-collection-load');
            }, 100);

            history.pushState({
                page: view_url
            }, null, view_url);

           // fetchReviews(view_url);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.log('AJAX Error: ' + textStatus + ' ' + errorThrown);
            console.log('AJAX Status: ' + jqXHR.status);
            console.log('AJAX Response: ' + jqXHR.responseText);
        }
    });
});

const holidayClasses = {
    collectionSidebar: '.holiday-sidebar',
    holidayHeading: '.holiday-filter-group:not(.sort-group)',
    accordionContent: '.accordion-content',
    holidayFilterItem: '.holiday-Linklist__Item:not(.sort-item)',
    sortItem: '.holiday-Linklist__Item.sort-item',
    filter: '.Linklist:not(.sort-list)',
};

// Accordion
const holidayHeading = $(holidayClasses.holidayHeading);

var destroyButton = document.getElementById('destroy');
document.addEventListener("DOMContentLoaded", function () {
    ajaxLoadElements();
});



holidayHeading.on('click', function () {
    const parentItem = $(this).parent();
    const content = parentItem.find(holidayClasses.accordionContent).first();

    $(this).toggleClass('open');
    content.slideToggle();
});

// Tag filter
const holidayURL = window.location.origin + window.location.pathname;
const holidayFilterItem = $(holidayClasses.holidayFilterItem);
let holidayCollectionURL = $(holidayClasses.collectionSidebar).data('collection-url');



holidayFilterItem.each(function () {
    const tag = $(this).data('tag');


});


$(document).ready(function() {
    if ($('body').hasClass('template-gift-finder')) {
        function throwConfetti(e) {
            // Burst of celebratory confetti!
            window.throwConfetti(document.getElementById("nav-confetti"), { angle: 90, spread: 15, startVelocity: 500, elementCount: 120, decay: 0.1 });
        }
        throwConfetti();
    }
});

holidayFilterItem.on('click', function () {
    let search = window.location.search;

    function throwConfetti(e) {
        // Burst of celebratory confetti!
        window.throwConfetti(document.getElementById("nav-confetti"), { angle: 90, spread: 20, startVelocity: 70, elementCount: 90, decay: 0.7 });
    }

    if ($('body').hasClass('sale-area') || $('body').hasClass('template-name-collection')) {
        var link_title = $(this).find('button').attr('data-value');

        if (link_title === 'SALE') {
            link_title = 'ALL SALE';
        }

        if (link_title === 'ALL GIFTS') {
            link_title = 'GIFT GUIDE';
            //console.log(document.getElementById('nav-confetti'))
            
        }

        if (link_title == "TODAY'S TOP 10") {
            $('body').addClass('best-sellers-sale-collection');
            $('.filters-toggle-btn').attr('aria-hidden', 'true');
            $('.filters-toggle-btn').attr('tabindex', '-1');
        } else {
            $('body').removeClass('best-sellers-sale-collection');
            $('.filters-toggle-btn').attr('aria-hidden', 'false');
            $('.filters-toggle-btn').attr('tabindex', '0');
        }

        if (link_title === 'SALE') {
            link_title = 'ALL SALE';
        }

        if ($('.main-breadcrumb').text() != link_title) {
            $('.breadcrumb-item:last-child').text(link_title);
            $('.breadcrumb-delimiter').text('>');
        } else {
            $('.breadcrumb-item:last-child').text('');
            $('.breadcrumb-delimiter').text('');
        }
    }

    $('.featured-collection-filter-ready').removeClass('featured-collection-filter-ready');
    $('.fake-select-open').removeClass('fake-select-open');

   
    var $this = $(this);

    var newholidayCollectionURL = $(this).attr('data-tag');

    $('.collection-filter-groups').attr('data-collection-url', newholidayCollectionURL);

    // Get all URL parameters
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    var currentSort = getUrlParameter('sort_by');

    if (currentSort != '') {
        newholidayCollectionURL += '?sort_by=' + currentSort
    }

    if (search.indexOf('page') !== -1) {
        const pageParam = search.split("&")[0];
        search = search.replace(pageParam, '').replace('&', '?');
    }

    $('.filtered--count').text('');
    $('.filtered-loading').css('display', 'block');


    const filter = $(this).parents('[data-filter]');
    const holidayFilterItems = filter.find(holidayClasses.holidayFilterItem);
    /* var addActiveClass = true;
     if ($(this).hasClass('active')) {
         addActiveClass = false
     }
     holidayFilterItems.removeClass('active');
     if (addActiveClass) {
         $(this).addClass('active');
     }*/

    if ($(this).hasClass('is-selected')) {

    } else {

    }

    if (link_title === 'GIFT GUIDE' && $(this).hasClass('is-selected')) {
        $("html, body").animate({
            scrollTop: 0
        }, 500);
    } else {
        if (link_title === 'GIFT GUIDE' && !$(this).hasClass('is-selected')) {
            throwConfetti();
        }
        $(this).toggleClass('is-selected').siblings().removeClass('is-selected');

    }

    var activeItems = $('.holiday-nav-filters').find(holidayClasses.holidayFilterItem + '.is-selected');
    var activeTags = [];

    activeItems.each(function (index, el) {
        var tag = $(el).attr('data-tag');

        if (tag) {
            activeTags.push(tag);
        }
    });



    var tagsUrl = activeTags.join('+');

    var newUrl = holidayCollectionURL;





    newUrl += search;

    $('.collection-container').addClass('ajax-loading');


    $('.holiday-nav-filters-inner').addClass('filtered-products-loading');
    var $this = $(this);



    if ($(window).width() > 834) {
        $("html, body").animate({
            scrollTop: 0
        }, 500);
       // console.log('scrolled to top');
    }

    if ($(window).scrollTop() != 0 && $(window).width() < 835) {
        $("html, body").animate({
            scrollTop: 0
        }, 500);
        //console.log('scrolled to top');
    }

    var nameValue = $this.attr('data-gtm-label');
    //console.log('Value: ' + nameValue);

    if (link_title === 'GIFT GUIDE') {
        newholidayCollectionURL = constructFilterUrl();
    }

    $.get({
        url: newholidayCollectionURL + "?view=ajax-pagination",
        success: function (data) {

            //console.log('Success');
            setTimeout(function () {

                //console.log('Products found 2');

                if (link_title == 'GIFT GUIDE') {
                    $('body').addClass('template-gift-finder');
                    setTimeout(function () {
                        $('.featured-collection-filter-wrapper').addClass('featured-collection-filter-ready');
                    },1000);
                } else {
                    $('body').removeClass('template-gift-finder');
                    
                }

                var newProductsWrapper = $(data).find("#product-grid");
                var newPagination = $(data).find(".pagination");
                var newPaginationHtml = newPagination.html();
                var newProductsHtml = newProductsWrapper.html();
                var $currentFilters = $('.collection-filter-groups-inner');
                var newFilters = $(data).find('.collection-filter-groups-inner').html();
                productsContainer.html(newProductsHtml);



                $currentFilters.html(newFilters);
                if (link_title != 'GIFT GUIDE') {
                    $('body').removeClass('plp--hide-brand-blocks');
                } else {
                    if (link_title === 'GIFT GUIDE' && $('.manually-filtered-dropdown').length) {
                        $('body').removeClass('plp--hide-brand-blocks');
                    }
                }


                autoplayPLPVideos();


                if ($(window).width() < 991) {




                    $(".card-brand-block").each(function (i) {
                        $(this).addClass("editorial--block-" + (i + 1));
                    });

                    $(".plp-product-standard").each(function (i) {
                        $(this).addClass("product--block-" + (i + 1));
                    });
                    setTimeout(function(){
                        if ($("main .plp-product-standard").length == 5 && $(window).width() < 991 && $('body').hasClass('template-gift-finder')) {
                            $(".card-brand-block").insertAfter("main .product--block-5");
                          }
                    },100);
                    

                    $(".editorial--block-1").insertAfter(".product--block-4");

                      if ($("body").hasClass("sale-collection-area")) {
                           $(".editorial--block-2").insertAfter(".product--block-12");

                            $(".editorial--block-3").insertAfter(".product--block-20");
                      
                            $(".editorial--block-4").insertAfter(".product--block-28");
                      
                            $(".editorial--block-5").insertAfter(".product--block-36");
                      
                            $(".editorial--block-6").insertAfter(".product--block-44");
                      
                            $(".editorial--block-7").insertAfter(".product--block-52");
                      }

                  






                }

                var newItemCount = newProductsWrapper.attr('data-products-count');
                $('.filtered-loading').css('display', 'none');
                $('.holiday-nav-filters-inner').removeClass('filtered-products-loading');
                $('.holiday-filter-groups-header .filtered--count').text(newItemCount + " Items");
                newProductsWrapper.attr('data-products-count', newItemCount);

                setTimeout(function () {
                    if (newProductsWrapper.attr('data-products-count') < 5) {
                        $('.pe--load-next-collection-wrapper').addClass('disable-collection-load');
                        $('.pe--load-more.pe--show-button').css('display', 'none');
                    } else {
                        $('.pe--load-next-collection-wrapper').removeClass('disable-collection-load');
                        $('.pe--load-more.pe--show-button').css('display', 'block');
                    }

                    if ($(window).width() < 835) {




                    }



                }, 0300);

                paginationIsLoading = !1;

                if ($('.mark-your-calendar-brand-block').length) {
                    attachMarkYourCalendarEvents();
                }

                ajaxLoadElements();
                setTimeout(function () {
                    if (newProductsWrapper.attr('data-products-count') > 49) {


                        $('.pagination').remove();
                        newPagination.insertAfter('#load-more-dump');


                      //  console.log('More than 24 products');
                        $('body').removeClass('collection-last-page-loaded');
                        $('.pe--load-more').removeClass('pe--show-button');
                        $('.spinner-gif').show();

                        setTimeout(function () {
                            if ($(".pagination-style-scroll").length) {
                                $(window).on(
                                    "scroll",
                                    _.throttle(
                                        function () {
                                            var limit = 3 * $(window).height();
                                            if ($(document).height() - $(window).scrollTop() < limit) {
                                                if (!paginationIsLoading) {
                                                    paginationIsLoading = !0;
                                                    $(".pagination-load-more").trigger("click");

                                                    //console.log('Loading');
                                                }
                                            }
                                        },
                                        250, {
                                            leading: !0,
                                            trailing: !0
                                        }
                                    )
                                );
                            }
                        }, 0500);
                    }

                    if (newProductsWrapper.attr('data-products-count') < 50) {
                        $('.pagination').remove();
                       // console.log('Less than 24');
                        $('body').addClass('collection-last-page-loaded');
                        $('.pe--load-more').addClass('pe--show-button');
                    }

                    if (newProductsWrapper.attr('data-products-count') < 25) {
                       // console.log('Less than 24');
                        $('body').addClass('collection-last-page-loaded');
                        $('.pe--load-more').addClass('pe--show-button');
                    }
                }, 0500);

                history.pushState({
                    page: newholidayCollectionURL
                }, null, newholidayCollectionURL);

               // fetchReviews(newholidayCollectionURL);
                setTimeout(function () {
                    $('.collection-container').removeClass('ajax-loading');
                }, 0300);
            }, 0100);
        }
    });



});

document.addEventListener("DOMContentLoaded", function () {
    // Find the div with class "holiday-filter-nav"
    const holidayNav = document.querySelector(".holiday-filter-nav");

    // If the div is found, set the "--has-holiday-nav" CSS variable to true
    if (holidayNav) {
        document.documentElement.style.setProperty("--has-holiday-nav", "true");
    }
});



if ($(window).width() < 835 && ($('body').hasClass('template-ALL SALE-best-sellers') || $('body').hasClass('template-ALL SALE-going-fast-sale'))) {
    var offsetIsSelected = $('.is-selected').offset();

    $('.holiday-filter-contents ul').animate({
        scrollLeft: offsetIsSelected.left
    });
}

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(function () {
        $('main .plp-product-standard:first-child').addClass('nudge-image');
    }, 0500);
    setTimeout(function () {
        $('main .plp-product-standard:first-child').removeClass('nudge-image');
    }, 1000);


    if (($('body').hasClass('sale-area') && !$('body').hasClass('template-product')) || ($('body').hasClass('special-collection') && !$('body').hasClass('template-product'))) {

        setTimeout(function () {
            $('.holiday-filter-nav').addClass('nudge-nav');
        }, 3000);
        setTimeout(function () {
            $('.holiday-filter-nav').removeClass('nudge-nav');
        }, 4000);
    }




});




$(document).ready(function () {
    if ($(window).width() > 990) {
        $('.filter-toggle').each(function(){
            var $this = $(this);
            $this.attr('aria-expanded', true);
            $this.attr('tabindex', '-1');
        });
    }
});






function giftFinderPLPElements(data, newUrl) {
    $('body').addClass('plp--hide-brand-blocks');
    //$('.filters-bar').addClass('show-filters-bar');
    var newProductsWrapper = $(data).find("#product-grid");
    var newItemCount = newProductsWrapper.attr('data-products-count');
    if ($('.manually-filtered-dropdown').length == 1 && newProductsWrapper.find('.plp-product-standard').length > 20) {
        var firstTenProducts = newProductsWrapper.find('.plp-product-grid-item').slice(0, 21);
        $('.collection-grid__products').attr('data-products-count', 20);

       // $('body').addClass('plp--hide-brand-blocks');

    } else if ($('.manually-filtered-dropdown').length == 2 && newProductsWrapper.find('.plp-product-standard').length > 15) {

        var firstTenProducts = newProductsWrapper.find('.plp-product-grid-item').slice(0, 16);
        $('.collection-grid__products').attr('data-products-count', 15);
       // $('body').addClass('plp--hide-brand-blocks');

    } else if ($('.manually-filtered-dropdown').length == 3) {
        var firstTenProducts = newProductsWrapper.find('.plp-product-grid-item').slice(0, 11);
        $('.collection-grid__products').attr('data-products-count', 10);
       // $('body').addClass('plp--hide-brand-blocks');

    } else {
        var firstTenProducts = newProductsWrapper.find('.plp-product-grid-item');
        $('.collection-grid__products').attr('data-products-count', newItemCount);

        //$('body').removeClass('plp--hide-brand-blocks');

        setTimeout(function () {
            autoplayPLPVideos();
        },1000);

    }
    setTimeout(function () {
        $("main .plp-product-standard").each(function (i) {
            $(this).addClass("product--block-" + (i + 1));
        });

        if ($("main .plp-product-standard").length == 5 && $(window).width() < 991) {
            $(".card-brand-block").insertAfter("main .product--block-5");
        }
    },100);

    

   $('body').removeClass('plp--hide-brand-blocks');

    if ($('.manually-filtered-dropdown').length == 1) {
       // $('body').addClass('plp--hide-brand-blocks');

    } else if ($('.manually-filtered-dropdown').length == 2) {
       // $('body').addClass('plp--hide-brand-blocks');

    } else if ($('.manually-filtered-dropdown').length == 3) {
       // $('body').addClass('plp--hide-brand-blocks');

    } else {
       // $('body').removeClass('plp--hide-brand-blocks');
    }
    var limitedProductsHtml = $('<div>').append(firstTenProducts).html();

    var newPagination = $(data).find(".pagination");
    var newPaginationHtml = newPagination.html();
    var newProductsHtml = newProductsWrapper.html();
    

    if ($('.featured-collection-selected-filter[data-display-text=""]').length === 3) {
        newItemCount = '';
    }

    
    if (limitedProductsHtml) {
        productsContainer.html(limitedProductsHtml);
       // console.log('Products found');
    } else {

        let emptyCollection = $(data).find('#emptyCollection');
        let emptyCollectionHTML = emptyCollection.html();
       // console.log('no products found');

        $('.pe--load-more').css('display', 'none');

        productsContainer.empty();

        if (emptyCollectionHTML) {
            productsContainer.append(emptyCollectionHTML);
        } else {
           // console.log('no products message found');
            productsContainer.append('<div class="title-wrapper center"><h2 class="title title--primary">Oops, you stumped Santa!<br><a href="{{ collection.url }}" class="underlined-link link clear-all-link">Clear all</a> or select different options.</h2></div>');
        }
    }

    setTimeout(function () {
    $('body').removeClass('getting-gifts');
    },1500);



    if ($('.main-filter[data-tag="lens_polarized"]').hasClass('is-selected')) {

        $('body').addClass('polarized-filter-selected');

    } else {
        $('body').removeClass('polarized-filter-selected');
    }



    $('.filtered-loading').css('display', 'none');
    $('.collection-filter-groups-inner').removeClass('filtered-products-loading');
    if (newItemCount) {
        if ($('body').hasClass('gift-collection')) {
            $('.filter-groups-header .filtered--count').text(newItemCount + " Gifts");
        } else {
            $('.filter-groups-header .filtered--count').text(newItemCount + " Frames");
        }

        $('.gift-count').text(newItemCount)
    } else {
        newItemCount = 0;
        if ($('body').hasClass('gift-collection')) {
            $('.filter-groups-header .filtered--count').text("0 Gifts");
        } else {
            $('.filter-groups-header .filtered--count').text("0 Frames");
        }

        $('.gift-count').text('')
    }
    
    paginationIsLoading = !1;

    ajaxLoadElements();
    if ($('.mark-your-calendar-brand-block').length) {
        attachMarkYourCalendarEvents();
    }
    if (newProductsWrapper.attr('data-products-count') > 49) {


        $('.pagination').remove();
        newPagination.insertAfter('#load-more-dump');


       // console.log('More than 24 products');
        $('body').removeClass('collection-last-page-loaded');
        $('.pe--load-more').removeClass('pe--show-button');
        $('.spinner-gif').show();

        setTimeout(function () {
            if ($(".pagination-style-scroll").length) {
                $(window).on(
                    "scroll",
                    _.throttle(
                        function () {
                            var limit = 3 * $(window).height();
                            if ($(document).height() - $(window).scrollTop() < limit) {
                                if (!paginationIsLoading) {
                                    paginationIsLoading = !0;
                                    $(".pagination-load-more").trigger("click");

                                   // console.log('Loading');
                                }
                            }
                        },
                        250, {
                            leading: !0,
                            trailing: !0
                        }
                    )
                );
            }
        }, 0500);
    }

    if (newProductsWrapper.attr('data-products-count') < 50) {
        $('.pagination').remove();
       // console.log('Less than 24');
        $('body').addClass('collection-last-page-loaded');
        $('.pe--load-more').addClass('pe--show-button');
    }

    if (newProductsWrapper.attr('data-products-count') < 25) {
      //  console.log('Less than 24');
        $('body').addClass('collection-last-page-loaded');
        $('.pe--load-more').addClass('pe--show-button');
    }
    history.pushState({
        page: newUrl
    }, null, newUrl);
    $('.collection-container').removeClass('ajax-loading');
    //fetchReviews(newUrlRequest);
    
}




var refreshInterval; 
// Function to construct the filter URL
function constructFilterUrlRaw() {
  // Get all selected filter values that have been manually set by the user
  var filters = $('.featured-collection-filters .manually-filtered-dropdown').map(function() {
    return $(this).find('.featured-collection-selected-filter').attr('data-tag');
  }).get().join('+');
  
  // If filters are selected, construct the URL with filters
  // Otherwise, return the default URL
  return filters ? `/collections/all-gifts/${filters}?view=gift-finder-plp` : "/collections/all-gifts?view=gift-finder-plp";
}

function constructFilterUrl() {
    // Get all selected filter values that have been manually set by the user
    var filters = $('.featured-collection-filters .manually-filtered-dropdown').map(function() {
      return $(this).find('.featured-collection-selected-filter').attr('data-tag');
    }).get().join('+');
    
    // If filters are selected, construct the URL with filters
    // Otherwise, return the default URL
    return filters ? `/collections/all-gifts/${filters}` : "/collections/all-gifts";
  }

//refreshInterval = setInterval(clickGO, 5000);

// Function to refresh the featured products based on filters
function refreshTopTen() {
  

  // Construct the filter URL and log it to the console
  var filterUrlRaw = constructFilterUrlRaw();

  var filterUrl = constructFilterUrl();
  //console.log('Filter URL:', filterUrl); // Log the filter URL for debugging

  //console.log('This fired');

  $('.featured-collection-filters select').each(function(){
    $(this).addClass('manually-filtered')
  })

  $('body').addClass('getting-gifts');
  
  // Fetch the filtered or default product contents
  fetch(filterUrlRaw, { method: "GET" })
    .then((response) => response.text())
    .then((productContents) => {
    
        $('.holiday-main-filter.all-gifts').addClass('option-selected');

      
        giftFinderPLPElements(productContents, filterUrl)
      
    })
    .catch((errorMsg) => {
      console.error('Error fetching filtered products:', errorMsg);
    });
}
// Function to handle filter change events
function onFilterChange() {
  // Toggle the 'manually-filtered' class based on whether a non-default option is selected
  $(this).toggleClass('manually-filtered', this.value !== '');
  setTimeout(function(){
    refreshTopTen(); // Refresh products with the new filters
  },100);

 
}

// Attach the filter change event handler to all filter dropdowns
$('.featured-collection-filters select').on('change', onFilterChange);


$(document).on('click', '.fake-select-dropdown li:not(.featured-collection-selected-filter)', function() {
    // Get the data-tag of the clicked option
    var selectedTag = $(this).attr('data-tag');
    var selectedTagDisplayText = $(this).attr('data-display-text');

    //console.log('Selected tag:', selectedTag); // Check the value of selectedTag


    // Find the associated real select dropdown
    // Assuming that the real select dropdown is in the same 'li' as the fake dropdown
    var realSelect = $(this).parents('.featured-collection-filter-group').find('select');

    // Update the real select dropdown
    realSelect.val(selectedTag); // Trigger the change event on the real select
    //console.log('Value of dropdown after setting:', realSelect.val()); // Check the value right after setting


    $(this).parents('.featured-collection-filter-group').find('select').trigger('change');

    //console.log('Change event triggered');


   




    // Optionally, update the custom dropdown to reflect the selection
    $(this).parents('.fake-select-dropdown').find('.featured-collection-selected-filter').html($(this).html());
    $(this).parents('.fake-select-dropdown').find('.featured-collection-selected-filter').attr('data-tag', selectedTag);
    $(this).parents('.fake-select-dropdown').find('.featured-collection-selected-filter').attr('data-display-text', selectedTagDisplayText);


    $(this).parents('.fake-select-dropdown').find('li:not(.featured-collection-selected-filter)').removeClass('featured-collection-active-filter-hide');
    $(this).parents('.fake-select-dropdown').find('li[data-tag="' + selectedTag + '"]:not(.featured-collection-selected-filter)').addClass('featured-collection-active-filter-hide');


    if ($(this).hasClass('blank-filter')) {
        $(this).parents('.fake-select-dropdown').removeClass('manually-filtered-dropdown');
        $(this).parents('.fake-select-dropdown').find('.featured-collection-selected-filter').addClass('no-option-selected');
    } else {
        $(this).parents('.fake-select-dropdown').addClass('manually-filtered-dropdown');

        $(this).parents('.fake-select-dropdown').find('.featured-collection-selected-filter').removeClass('no-option-selected');

        $("body:not(.template-index) .fake-filter-slider").slick('unslick');
    }
});

    $(document).on('click', '.fake-select-dropdown .featured-collection-selected-filter', function() {
        $('.template-index .fake-filter-slider').slick('slickPause');
        $('.featured-collection-filters select').each(function(){
        $(this).addClass('manually-filtered')
        })
    });

    $(document).on('click', '.featured-collection-filter-group.fake-select-open li', function(){
        $(this).parents('.fake-select-dropdown').find('.initial-filter-load').removeClass('initial-filter-load');
    });

    $(document).on('click', '.fake-select-open .fake-select-dropdown', function(){
        var $this = $(this);
        $this.parents('.featured-collection-filter-group').addClass('fake-select-closing');
        $this.parents('.featured-collection-filter-group').removeClass('fake-select-open');
        setTimeout(function(){
            $this.parents('.featured-collection-filter-group').removeClass('fake-select-closing');
        },800);
    });

    $(document).on('click', '.featured-collection-filter-group:not(.fake-select-open) .fake-select-dropdown, .featured-collection-filter-group:not(.fake-select-open) .toggle-select-dropdown', function(){
        var $this = $(this);
        $('.featured-collection-filter-group').removeClass('fake-select-open');

        $this.parents('.featured-collection-filter-group').addClass('fake-select-open');

    });




function clickGO(){
    $('.go-gg-trigger')[0].click();
}

// Click event handler for the "Go" button
$('.go-gg-trigger').on('click', function() {
    // Construct the filter URL
    var goUrl = constructGoButtonUrl();
    // Redirect the user to the constructed URL
    //refreshGiftFinder(goUrl);
});


// Click event for dropdowns
$(document).on('click', '.fake-select-dropdown', function() {

 

    $('body').addClass('fake-select-clicked');
    
});

$(document).on('click', function(event) {
    // Check if the clicked area is not within an open dropdown
    if (!$(event.target).closest('.fake-select-open').length) {
        // Close all open dropdowns
        $('.featured-collection-filter-group').addClass('fake-select-closing');
        $('.featured-collection-filter-group').removeClass('fake-select-open');

        setTimeout(function(){
            $('.featured-collection-filter-group').removeClass('fake-select-closing');
        },800);
    }
});

$(document).on('click', '.featured-collection-filter-group.fake-select-open label', function(e) {
    e.preventDefault();
    var $this = $(this);
    $this.parents('.featured-collection-filter-group').addClass('fake-select-closing');
    $this.parents('.featured-collection-filter-group').removeClass('fake-select-open');
    setTimeout(function(){
        $this.parents('.featured-collection-filter-group').removeClass('fake-select-closing');
    },800);
});

$(document).on('click', '.fake-select-open .toggle-select-dropdown', function(e) {
    var $this = $(this);
    $this.parents('.featured-collection-filter-group').addClass('fake-select-closing');
    $this.parents('.featured-collection-filter-group').removeClass('fake-select-open');
    setTimeout(function(){
        $this.parents('.featured-collection-filter-group').removeClass('fake-select-closing');
    },800);
});